// extracted by mini-css-extract-plugin
export default {"banner":"DunningBanner_banner__xsos3","icon":"DunningBanner_icon__9lAwP","message":"DunningBanner_message__MCqd6","cta":"DunningBanner_cta__k8o8Z"};